import { Title } from "components";
import { DonateCodes } from "./components";

export default function Connect() {
  return (
    <div className="lg:h-screen flex flex-col justify-center items-center">
      <div className="lg:w-[600px] flex flex-col items-center">
        <Title className="mb-6 pt-8 lg:pt-0">DONATE</Title>
        <div className="lg:text-sm mb-10 px-4 lg:px-0">
          Donations directly support production costs, prop acquisition,
          costumes, studio rentals, music composition and editing, hiring and
          fairly paying artist collaborations, marketing, festival travel, and
          professional photo and/or video documentation. These costs for smaller
          works (typically solos or duets under 10 minutes) can be anywhere from
          $800–$2,500, while evening-length group productions range between
          $10,000-$15,000 (and upwards of $20,000 depending on cast size,
          rehearsal duration, and prop use). While much of this is funded
          through grants or out-of-pocket, your support allows me to redirect my
          time and energy from preparing financial reports and submitting
          proposals, toward artistic development. If my work has resonated with
          you and you'd like to see more, I invite you to contribute any amount*
          ($5 can get us bandaids, ice-packs, ibprophen) to help sustain,
          develop, and further my formal productions and free community art
          offerings in Texas— and beyond.
        </div>
        <Title className="mb-6">HOW</Title>
        <DonateCodes />
        <div className="w-full border-t border-dotted border-black mb-8 hidden lg:flex"></div>
      </div>
    </div>
  );
}
